import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'
import Message from 'components/text/Message/Message'
import InlineSvg from 'components/_new/ui/InlineSvg/InlineSvg'

import s from './LinkWithIcon.scss'


const LinkWithIcon = (props) => {
  const {
    className, title, icon, iconClassName, emojiIcon,
    messageName, withHtmlTitle, inlineSvg,  ...rest
  } = props

  return (
    <Link className={className} {...rest}>
      {
        icon ? (
          <span className={s.withIcon}>
            {
              inlineSvg ? (
                <InlineSvg className={cx(s.icon, iconClassName)} src={icon} cache />
              ) : (
                <img className={cx(s.icon, iconClassName)} src={icon} alt="icon" draggable={false} />
              )
            }
            <Message text={title} messageName={messageName} html={withHtmlTitle} />
          </span>
        ) : (
          <Fragment>
            {
              Boolean(emojiIcon) && (
                <span>{emojiIcon} </span>
              )
            }
            <Message text={title} messageName={messageName} html={withHtmlTitle} />
          </Fragment>
        )
      }
    </Link>
  )
}

LinkWithIcon.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  messageName: PropTypes.string,
  icon: PropTypes.string,
  emojiIcon: PropTypes.string,
  inlineSvg: PropTypes.bool,
  to: PropTypes.string,
  redirect: PropTypes.string,
  mailto: PropTypes.string,
  brandColor: PropTypes.bool,
  blackColor: PropTypes.bool,
  grayColor: PropTypes.bool,
  blackToBrandColor: PropTypes.bool,
  customColor: PropTypes.bool,
  styleless: PropTypes.bool,
  withHtmlTitle: PropTypes.bool,
  underlineBrandColor: PropTypes.bool,
}

LinkWithIcon.defaultProps = {
  brandColor: false,
  blackColor: false,
  customColor: false,
  withHtmlTitle: false,
}


export default LinkWithIcon
